import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ShoppingBag, Search, Truck, Shield, Clock } from 'lucide-react';
import { useCart } from '../context/CartContext';
import SearchOverlay from './SearchOverlay';
import CartPopup from './CartPopup';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [cartPopupOpen, setCartPopupOpen] = useState(false);
  const {
    cartItems
  } = useCart();
  const cartPopupRef = useRef<HTMLDivElement>(null);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const toggleSearch = () => {
    setSearchOpen(!searchOpen);
  };
  const toggleCartPopup = () => {
    setCartPopupOpen(!cartPopupOpen);
  };
  // Close cart popup when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (cartPopupRef.current && !cartPopupRef.current.contains(event.target as Node)) {
        setCartPopupOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return <>
      <nav className="bg-white shadow-lg" data-id="element-383">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-384">
          <div className="flex justify-between h-16" data-id="element-385">
            <div className="flex items-center" data-id="element-386">
              <div className="flex-shrink-0 flex items-center" data-id="element-387">
                <Link to="/" data-id="element-388">
                  <img className="h-10 w-auto" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTr3OIOItvNmTn92A0WvwPYsp3--3wl0xZVhg&s" alt="Shiriaka Essentials" onError={e => {
                  e.currentTarget.src = 'https://ui-avatars.com/api/?name=Shiriaka&background=e8f5e9&color=2e7d32&size=70&bold=true';
                }} data-id="element-389" />
                </Link>
              </div>
              <div className="hidden sm:ml-10 sm:flex sm:space-x-8" data-id="element-390">
                <Link to="/" className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium" data-id="element-391">
                  Home
                </Link>
                <Link to="/products" className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium" data-id="element-392">
                  Shop
                </Link>
                <Link to="/ria-skincare" className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium" data-id="element-393">
                  Ria Skincare
                </Link>
                <Link to="/blog" className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium" data-id="element-394">
                  Blog
                </Link>
                <Link to="/about" className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium" data-id="element-395">
                  About
                </Link>
                <Link to="/contact" className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium" data-id="element-396">
                  Contact
                </Link>
              </div>
            </div>
            <div className="flex items-center" data-id="element-397">
              <button onClick={toggleSearch} className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" data-id="element-398">
                <Search className="h-5 w-5" data-id="element-399" />
              </button>
              <div className="relative" ref={cartPopupRef} data-id="element-400">
                <button onClick={toggleCartPopup} className="ml-4 p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none relative" data-id="element-401">
                  <ShoppingBag className="h-5 w-5" data-id="element-402" />
                  {cartItems.length > 0 && <span className="absolute top-0 right-0 h-4 w-4 text-xs bg-[#2e7d32] text-white rounded-full flex items-center justify-center transform translate-x-1 -translate-y-1" data-id="element-403">
                      {cartItems.length}
                    </span>}
                </button>
                <CartPopup isOpen={cartPopupOpen} onClose={() => setCartPopupOpen(false)} data-id="element-404" />
              </div>
              <div className="-mr-2 ml-4 flex items-center sm:hidden" data-id="element-405">
                <button onClick={toggleMenu} className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#2e7d32]" data-id="element-406">
                  <span className="sr-only" data-id="element-407">Open main menu</span>
                  {isOpen ? <X className="block h-6 w-6" data-id="element-408" /> : <Menu className="block h-6 w-6" data-id="element-409" />}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile menu */}
        <div className={`${isOpen ? 'block' : 'hidden'} sm:hidden`} data-id="element-410">
          <div className="pt-2 pb-3 space-y-1" data-id="element-411">
            <Link to="/" className="bg-white border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium" data-id="element-412">
              Home
            </Link>
            <Link to="/products" className="bg-white border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium" data-id="element-413">
              Shop
            </Link>
            <Link to="/ria-skincare" className="bg-white border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium" data-id="element-414">
              Ria Skincare
            </Link>
            <Link to="/blog" className="bg-white border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium" data-id="element-415">
              Blog
            </Link>
            <Link to="/about" className="bg-white border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium" data-id="element-416">
              About
            </Link>
            <Link to="/contact" className="bg-white border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium" data-id="element-417">
              Contact
            </Link>
          </div>
        </div>
        <SearchOverlay isOpen={searchOpen} onClose={() => setSearchOpen(false)} data-id="element-418" />
      </nav>
      {/* Green stripe with delivery information */}
      <div className="bg-[#2e7d32] text-white py-2" data-id="element-419">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-420">
          <div className="flex flex-wrap justify-center sm:justify-between items-center text-sm" data-id="element-421">
            <div className="flex items-center mx-4 my-1" data-id="element-422">
              <Truck className="h-4 w-4 mr-2" data-id="element-423" />
              <span data-id="element-424">Free Delivery on Orders Over KSh 5,000</span>
            </div>
            <div className="flex items-center mx-4 my-1" data-id="element-425">
              <Shield className="h-4 w-4 mr-2" data-id="element-426" />
              <span data-id="element-427">100% Secure Payment</span>
            </div>
            <div className="flex items-center mx-4 my-1" data-id="element-428">
              <Clock className="h-4 w-4 mr-2" data-id="element-429" />
              <span data-id="element-430">Same-Day Dispatch for Orders Before 2PM</span>
            </div>
          </div>
        </div>
      </div>
    </>;
};
export default Navbar;